import '../../style/index.less';
import './index.less';
// style dependencies
import '../../select/style';
import '../../input/style';



// WEBPACK FOOTER //
// ./components/pagination/style/index.tsx